interface StatusBadgeProps {
  status: string;
  isAvailableToRefund: boolean;
}

const STATUS_STYLES = {
  REFUNDED: { color: 'bg-success-500', text: 'Estornado' },
  OPEN_PENDING: { color: 'bg-warning-500', text: 'Pendente' },
  OPEN_IN_STORE: { color: 'bg-primary-300', text: 'Em loja' },
  CANCELED: { color: 'bg-neutral-500', text: 'Cancelado' },
  DEFAULT: { color: 'bg-neutral-300', text: '' },
} as const;

const resolveOpenStatus = (isAvailableToRefund: boolean) =>
  isAvailableToRefund
    ? STATUS_STYLES.OPEN_PENDING
    : STATUS_STYLES.OPEN_IN_STORE;

const STATUS: Record<
  string,
  (isAvailableToRefund: boolean) => { color: string; text: string }
> = {
  REFUNDED: () => STATUS_STYLES.REFUNDED,
  OPEN: resolveOpenStatus,
  CANCELED: () => STATUS_STYLES.CANCELED,
};

const getStatusProps = (status: string, isAvailableToRefund: boolean) =>
  STATUS[status]?.(isAvailableToRefund) ?? {
    ...STATUS_STYLES.DEFAULT,
    text: status,
  };

export function StatusBadge({ status, isAvailableToRefund }: StatusBadgeProps) {
  if (!status) return null;

  const { color, text } = getStatusProps(status, isAvailableToRefund);

  return (
    <div className={`px-2 py-0.5 rounded-lg ${color}`}>
      <p className="text-xs font-bold text-neutral-100">{text}</p>
    </div>
  );
}
